import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useJamaah } from "@/context/JamaahContext";
import { jamaahApi, JAMAAH_TOKEN_KEY } from "@/lib/jamaahApi";
import { errMsg } from "@/lib/api";
import { Field } from "./JamaahFields";

export const ForgotForm = ({ onBack }) => {
  const { setJamaah } = useJamaah();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [masked, setMasked] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await jamaahApi.post("/jamaah/auth/forgot", { phone });
      setMasked(data.masked);
      setStep(2);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 6) return setError("Kata sandi minimal 6 karakter");
    if (pw !== confirm) return setError("Konfirmasi kata sandi tidak sama");
    setLoading(true);
    try {
      const { data } = await jamaahApi.post("/jamaah/auth/reset", { phone, code, new_password: pw });
      localStorage.setItem(JAMAAH_TOKEN_KEY, data.token);
      setJamaah(data.jamaah);
      navigate("/portal");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={step === 1 ? sendCode : reset} className="space-y-4" data-testid="forgot-form">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1 text-sm text-emerald-800 hover:underline" data-testid="forgot-back-btn"><ArrowLeft size={14} /> Kembali ke Masuk</button>
      <p className="text-sm text-slate-600">{step === 1 ? "Masukkan No. HP/WA yang terdaftar. Kami akan mengirim kode reset via WhatsApp." : `Kode telah dikirim ke ${masked}. Masukkan kode dan kata sandi baru.`}</p>
      <Field id="forgot-phone" label="No. HP / WA" required>
        <Input id="forgot-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required disabled={step === 2} placeholder="081234567890" data-testid="forgot-phone-input" />
      </Field>
      {step === 2 && (
        <>
          <Field id="forgot-code" label="Kode Reset (6 digit)" required>
            <Input id="forgot-code" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} required maxLength={6} data-testid="forgot-code-input" />
          </Field>
          <div className="grid sm:grid-cols-2 gap-3">
            <Field id="forgot-pw" label="Kata Sandi Baru" required>
              <Input id="forgot-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="forgot-password-input" />
            </Field>
            <Field id="forgot-confirm" label="Konfirmasi" required>
              <Input id="forgot-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="forgot-confirm-input" />
            </Field>
          </div>
        </>
      )}
      {error && <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="forgot-error">{error}</p>}
      <Button type="submit" className="w-full rounded-full h-11 emerald-bg hover:bg-[#145c48]" disabled={loading} data-testid="forgot-submit-btn">
        {loading ? <Loader2 className="animate-spin" size={18} /> : step === 1 ? "Kirim Kode via WhatsApp" : "Simpan Kata Sandi Baru"}
      </Button>
    </form>
  );
};
